import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Footer, StickyFooter } from '@rtn-web/rtn-common-components/dist';
// import NavigationLogoOnly from '../components/NavigationLogoOnly';
// import HigherEdFinderFooter from '../components/HigherEdFinder/higheredFooter';
// import HigherEdFinderHeaderNoLinks from '../components/HigherEdFinder/higheredHeaderNoLinks';
import TagManager from 'react-gtm-module';
import { Navigation as SharedNav, Footer as SharedFooter } from '@rtn-partners/rtn-shared-modules';
import { initGA, logPageView } from '../Utilities/analyitics';

const navConfig = require('../userNav.json');

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = { mediumOrLess: false };
    // medium foundation breakpoint
    this.mediumBreakpoint = 1025;
    this.screenResize = () => this.handleScreenResize();
  }

  handleScreenResize() {
    const { innerWidth } = window;
    if (innerWidth < this.mediumBreakpoint) this.setState({ mediumOrLess: true });
    else if (innerWidth > this.mediumBreakpoint) this.setState({ mediumOrLess: false });
  }

  componentDidMount() {
    console.log('mount');
    window.addEventListener('resize', this.screenResize);
    this.handleScreenResize();
    const { googleAnaltyicsId, gtmId } = this.props;
    TagManager.initialize({ gtmId });
    if (!window.GA_INITIALIZED) {
      initGA(googleAnaltyicsId);
      window.GA_INITIALIZED = true;
    }
    logPageView();
    this.injectHomeLink();
  }

  injectHomeLink() {
    const com = navConfig.COM || 'https://roadtripnation.com';
    document.querySelector("a[href$='/']").setAttribute('href', `${com}`);
  }

  componentWillUnmount() {
    console.log('unmount');
  }

  // gaTrack = (path) => {
  // ReactGA.pageview(path);
  // };

  renderHeader() {
    const { sanityData } = this.props;
    // const { mediumOrLess } = this.state;
    const signOut = false;

    const localCom = navConfig.COM;

    //  <a target href={localCom} aria-label="Return to homepage"></a>
    return (
      <div className="navbar-shared-module">
        <SharedNav
          nav={sanityData.nav}
          socialIcons={sanityData.socialIcons}
          loggedIn={signOut}
        />
      </div>
    );
  }

  renderFooter() {
    const { sanityData } = this.props;

    return (
      <div className="footer-shared-module">
        <SharedFooter footer={sanityData.footer} socialIcons={sanityData.socialIcons} />
      </div>
    );
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <div role="main" className="bg-topography h100">
          {this.renderHeader()}
          <div className="circles">
            <div className="circle-1" />
            <div className="circle-2" />
            <div className="circle-3" />
            <div className="circle-4" />
          </div>
          <div className="content-container">
            <div className="content">
              {children}
            </div>
          </div>
        </div>
        <div>
          { this.renderFooter() }
        </div>
      </div>
    );
  }
}

Layout.propTypes = {
  googleAnaltyicsId: PropTypes.string.isRequired,
  gtmId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  user: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]).isRequired,
  highered: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  smartPlan: PropTypes.object,
  setUser: PropTypes.func.isRequired,
};
Layout.defaultProps = {
  highered: false,
  children: null,
  highered: false,
  smartPlan: {},
  subscription: '',
};

function mapStateToProps({ user, main, smallCFNav }) {
  return {
    // heads up, user is not used anymore, keeping the setup in case its needed to be hooked later
    user,
    userId: user.userId,
    subscription: user.subscription,
    isAdminCom: user.isAdminCom,
    key: user.key,
    highered: main.highered,
    googleAnaltyicsId: main.googleAnaltyicsId,
    gtmId: main.gtmId,
    smallCFNav,
    sanityData: main.sanityData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setUser: (user) => dispatch(setUser(user)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Layout);
